module.exports = __webpack_public_path__ + "img/hugh.339e78ff.jpg";